import { render, staticRenderFns } from "./paymentMethod.vue?vue&type=template&id=5d9d8946&"
import script from "./paymentMethod.vue?vue&type=script&lang=js&"
export * from "./paymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports